import type { ConfigData, FeatureFlag } from '@/types/app';

/**
 * Whether a feature flag is enabled for the current origin.
 *
 * The backend `/config` endpoint returns `active_feature_flags`, the list of
 * enabled flag names; a flag is active iff it appears there. While the config
 * is still loading the list is undefined, so callers pass `defaultWhileLoading`
 * to preserve their pre-load behaviour (e.g. flags that should default on).
 *
 * @param config - The loaded config (or a partial holding `active_feature_flags`).
 * @param flag - The flag to check.
 * @param defaultWhileLoading - Value to return while the config has not loaded yet.
 */
export function isFeatureActive(
	config: Pick<ConfigData, 'active_feature_flags'> | undefined | null,
	flag: FeatureFlag,
	defaultWhileLoading = false
): boolean {
	const active = config?.active_feature_flags;
	if (!Array.isArray(active)) {
		return defaultWhileLoading;
	}
	return active.includes(flag);
}
